import * as actionTypes from "./actions";

const initialState = {
  isAuthorised: false,
  userId: 0,
  authToken: "",
  orderStatusUpdate: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_REDUX_STATE:
      return initialState; // Reset to the initial state

    case actionTypes.ADMIN_MASTER_LOADER:
      return {
        ...state,
        adminMasterLoader: action.payload.adminMasterLoader,
      };

    case actionTypes.ADMIN_AUTHORIZED:
      return {
        ...state,
        isAuthorised: action.payload.authState,
        userId: action.payload.userId,
        authToken: action.payload.authToken,
      };

    case actionTypes.ORDER_STATUS_UPDATE:
      return {
        ...state,
        orderStatusUpdate: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
